import BaseItem, { Rarity } from './base_item';

export default class Table extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "table.png");
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 20;}
    static get height() { return 12;}

    static get mass() { return 2;}
    static get electronic() { return false; }
    static get rarity() { return Rarity.COMMON; }

    static get type() { return 'table'}
    static get label() { return 'table'}
    static get description() { return `A table. Sometimes a bed. Sometimes.. a friend.`}
}


// WEBPACK FOOTER //
// ./src/objects/items/table.js